export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';

export const ROLES = {
  ROLE_ADMIN: 'Администратор',
  ROLE_SUPER_ADMIN: 'Супер-администратор',
};

export const ADMIN_LIST = 'ADMIN_LIST';
export const ADMIN_CREATE = 'ADMIN_CREATE';
export const ADMIN_EDIT = 'ADMIN_EDIT';
export const ADMIN_DELETE = 'ADMIN_DELETE';
export const ADMIN_HISTORY = 'ADMIN_HISTORY';
export const ROLE_LIST = 'ROLE_LIST';
export const ROLE_CREATE = 'ROLE_CREATE';
export const ROLE_EDIT = 'ROLE_EDIT';
export const ROLE_DELETE = 'ROLE_DELETE';
export const ROLE_HISTORY = 'ROLE_HISTORY';
export const USER_LIST = 'USER_LIST';
export const USER_CREATE = 'USER_CREATE';
export const USER_EDIT = 'USER_EDIT';
export const USER_BLOCK = 'USER_BLOCK';
export const USER_DELETE = 'USER_DELETE';
export const USER_HISTORY = 'USER_HISTORY';
export const DICTIONARY_LIST = 'DICTIONARY_LIST';
export const DICTIONARY_CREATE = 'DICTIONARY_CREATE';
export const DICTIONARY_EDIT = 'DICTIONARY_EDIT';
export const DICTIONARY_VERIFY = 'DICTIONARY_VERIFY';
export const DICTIONARY_DELETE = 'DICTIONARY_DELETE';
export const DICTIONARY_HISTORY = 'DICTIONARY_HISTORY';
export const NEWS_LIST = 'NEWS_LIST';
export const NEWS_CREATE = 'NEWS_CREATE';
export const NEWS_EDIT = 'NEWS_EDIT';
export const NEWS_DELETE = 'NEWS_DELETE';
export const NEWS_PUBLISH = 'NEWS_PUBLISH';
export const NEWS_HISTORY = 'NEWS_HISTORY';
export const KEYWORDS_LIST = 'KEYWORDS_LIST';
export const KEYWORDS_CREATE = 'KEYWORDS_CREATE';
export const KEYWORDS_EDIT = 'KEYWORDS_EDIT';
export const KEYWORDS_DELETE = 'KEYWORDS_DELETE';
export const KEYWORDS_VIOLATIONS_LIST = 'KEYWORDS_VIOLATIONS_LIST';
export const KEYWORDS_HISTORY = 'KEYWORDS_HISTORY';
export const COMPLAINTS_LIST = 'COMPLAINTS_LIST';
export const COMPLAINTS_RESOLVE = 'COMPLAINTS_RESOLVE';
export const COMPLAINTS_HISTORY = 'COMPLAINTS_HISTORY';
export const FAKE_USER_LIST = 'FAKE_USER_LIST';
export const FAKE_USER_CREATE = 'FAKE_USER_CREATE';
export const FAKE_USER_EDIT = 'FAKE_USER_EDIT';
export const FAKE_USER_DELETE = 'FAKE_USER_DELETE';
export const PUBLICATION_CREATE = 'PUBLICATION_CREATE';
export const PUBLICATION_HISTORY = 'PUBLICATION_HISTORY';
export const ONBOARDING_LIST = 'ONBOARDING_LIST';
export const ONBOARDING_CREATE = 'ONBOARDING_CREATE';
export const ONBOARDING_DELETE = 'ONBOARDING_DELETE';
export const ONBOARDING_HISTORY = 'ONBOARDING_HISTORY';
export const RADAR_LIST = 'RADAR_LIST';
export const RADAR_EDIT= 'RADAR_EDIT';
export const SETTINGS_LIST = 'SETTINGS_LIST';
export const SETTINGS_EDIT = 'SETTINGS_EDIT';
export const SETTINGS_HISTORY = 'SETTINGS_HISTORY';
export const LOCALIZATION_LIST = 'LOCALIZATION_LIST';
export const LOCALIZATION_EDIT = 'LOCALIZATION_EDIT';
export const LOCALIZATION_CLEAR = 'LOCALIZATION_CLEAR';
export const LOCALIZATION_HISTORY = 'LOCALIZATION_HISTORY';
export const LOCALIZATION_LANGUAGE_CREATE = 'LOCALIZATION_LANGUAGE_CREATE';
export const LOCALIZATION_LANGUAGE_EDIT = 'LOCALIZATION_LANGUAGE_EDIT';
export const LOCALIZATION_LANGUAGE_PUBLISH = 'LOCALIZATION_LANGUAGE_PUBLISH';
export const LOCALIZATION_LANGUAGE_DELETE = 'LOCALIZATION_LANGUAGE_DELETE';
export const GIFT_CATEGORY_VIEW = 'GIFT_CATEGORY_VIEW';
export const GIFT_CATEGORY_EDIT = 'GIFT_CATEGORY_EDIT';
export const GIFT_CATEGORY_DELETE = 'GIFT_CATEGORY_DELETE';
export const GIFT_VIEW = 'GIFT_VIEW';
export const GIFT_EDIT = 'GIFT_EDIT';
export const MARKET_LIST = 'MARKET_LIST';
export const MARKET_CREATE = 'MARKET_CREATE';
export const MARKET_EDIT = 'MARKET_EDIT';
export const MARKET_DELETE = 'MARKET_DELETE';
export const COIN_PACKET_VIEW = 'COIN_PACKET_VIEW';
export const COIN_PACKET_EDIT = 'COIN_PACKET_EDIT';
export const COIN_PACKET_DELETE = 'COIN_PACKET_DELETE';
export const JJFORTUNE_VIEW = 'JJFORTUNE_VIEW';
export const JJFORTUNE_EDIT = 'JJFORTUNE_EDIT';


export const PERMISSIONS = {
  [ADMIN_LIST]: 'administration.permissions_admin_list',
  [ADMIN_CREATE]: 'administration.permissions_admin_create',
  [ADMIN_EDIT]: 'administration.permissions_admin_edit',
  [ADMIN_DELETE]: 'administration.permissions_admin_delete',
  [ADMIN_HISTORY]: 'administration.permissions_view_history',
  [ROLE_LIST]: 'administration.permissions_role_list',
  [ROLE_CREATE]: 'administration.permissions_role_create',
  [ROLE_EDIT]: 'administration.permissions_role_edit',
  [ROLE_DELETE]: 'administration.permissions_role_delete',
  [ROLE_HISTORY]: 'administration.permissions_view_history',
  [USER_LIST]: 'administration.permissions_user_list',
  [USER_CREATE]: 'administration.permissions_user_create',
  [USER_EDIT]: 'administration.permissions_user_edit',
  [USER_BLOCK]: 'administration.permissions_user_block',
  [USER_DELETE]: 'administration.permissions_user_delete',
  [USER_HISTORY]: 'administration.permissions_view_history',
  [DICTIONARY_LIST]: 'administration.permissions_dictionary_list',
  [DICTIONARY_CREATE]: 'administration.permissions_dictionary_create',
  [DICTIONARY_EDIT]: 'administration.permissions_dictionary_edit',
  [DICTIONARY_VERIFY]: 'administration.permissions_dictionary_verify',
  [DICTIONARY_DELETE]: 'administration.permissions_dictionary_delete',
  [DICTIONARY_HISTORY]: 'administration.permissions_view_history',
  [NEWS_LIST]: 'administration.permissions_news_list',
  [NEWS_CREATE]: 'administration.permissions_news_create',
  [NEWS_EDIT]: 'administration.permissions_news_edit',
  [NEWS_DELETE]: 'administration.permissions_news_delete',
  [NEWS_PUBLISH]: 'administration.permissions_news_publish',
  [NEWS_HISTORY]: 'administration.permissions_view_history',
  [KEYWORDS_LIST]: 'administration.permissions_keywords_list',
  [KEYWORDS_CREATE]: 'administration.permissions_keywords_create',
  [KEYWORDS_EDIT]: 'administration.permissions_keywords_edit',
  [KEYWORDS_DELETE]: 'administration.permissions_keywords_delete',
  [KEYWORDS_VIOLATIONS_LIST]: 'administration.permissions_keywords_violations_list',
  [KEYWORDS_HISTORY]: 'administration.permissions_view_history',
  [COMPLAINTS_LIST]: 'administration.permissions_complaints_list',
  [COMPLAINTS_RESOLVE]: 'administration.permissions_complaints_resolve',
  [COMPLAINTS_HISTORY]: 'administration.permissions_view_history',
  [FAKE_USER_LIST]: 'administration.permissions_fake_user_list',
  [FAKE_USER_CREATE]: 'administration.permissions_fake_user_create',
  [FAKE_USER_EDIT]: 'administration.permissions_fake_user_edit',
  [FAKE_USER_DELETE]: 'administration.permissions_fake_user_delete',
  [PUBLICATION_CREATE]: 'administration.permissions_publication_create',
  [PUBLICATION_HISTORY]: 'administration.permissions_view_history',
  [ONBOARDING_LIST]: 'administration.permissions_onboarding_list',
  [ONBOARDING_CREATE]: 'administration.permissions_onboarding_create',
  [ONBOARDING_DELETE]: 'administration.permissions_onboarding_delete',
  [ONBOARDING_HISTORY]: 'administration.permissions_view_history',
  [RADAR_LIST]: 'administration.permissions_radar_list',
  [RADAR_EDIT]: 'administration.permissions_radar_edit',
  [SETTINGS_LIST]: 'administration.permissions_settings_list',
  [SETTINGS_EDIT]: 'administration.permissions_settings_edit',
  [SETTINGS_HISTORY]: 'administration.permissions_view_history',
  [LOCALIZATION_LIST]: 'administration.permissions_localization_list',
  [LOCALIZATION_EDIT]: 'administration.permissions_localization_edit',
  [LOCALIZATION_CLEAR]: 'administration.permissions_localization_clear',
  [LOCALIZATION_HISTORY]: 'administration.permissions_view_history',
  [LOCALIZATION_LANGUAGE_CREATE]: 'administration.permissions_localization_language_create',
  [LOCALIZATION_LANGUAGE_EDIT]: 'administration.permissions_localization_language_edit',
  [LOCALIZATION_LANGUAGE_PUBLISH]: 'administration.permissions_localization_language_publish',
  [LOCALIZATION_LANGUAGE_DELETE]: 'administration.permissions_localization_language_delete',
  [GIFT_CATEGORY_VIEW]: 'administration.permissions_gifts_category_view',
  [GIFT_CATEGORY_EDIT]: 'administration.permissions_gifts_category_edit',
  [GIFT_CATEGORY_DELETE]: 'administration.permissions_gifts_category_delete',
  [GIFT_VIEW]: 'administration.permissions_gifts_view',
  [GIFT_EDIT]: 'administration.permissions_gifts_edit',
  [MARKET_LIST]: 'administration.permissions_market_list',
  [MARKET_CREATE]: 'administration.permissions_market_create',
  [MARKET_EDIT]: 'administration.permissions_market_edit',
  [MARKET_DELETE]: 'administration.permissions_market_delete',
  [COIN_PACKET_VIEW]: 'administration.permissions_coin_view',
  [COIN_PACKET_DELETE]: 'administration.permissions_coin_delete',
  [COIN_PACKET_EDIT]: 'administration.permissions_coin_edit',
  [JJFORTUNE_VIEW]: 'administration.permissions_jj_fortune.view',
  [JJFORTUNE_EDIT]: 'administration.permissions_jj_fortune.edit',
};

export const groupedPermissions = {
  ADMIN: {
    title: 'administration.permissions_admins',
    permissions: [ADMIN_LIST, ADMIN_CREATE, ADMIN_EDIT, ADMIN_DELETE, ADMIN_HISTORY],
  },
  ROLE: {
    title: 'administration.permissions_roles',
    permissions: [ROLE_LIST, ROLE_CREATE, ROLE_EDIT, ROLE_DELETE, ROLE_HISTORY],
  },
  USER: {
    title: 'administration.permissions_users',
    permissions: [USER_LIST, USER_EDIT, USER_CREATE, USER_BLOCK, USER_DELETE, USER_HISTORY],
  },
  CONTENT: {
    title: 'administration.permissions_admin_content',
    permissions: [
      FAKE_USER_LIST,
      FAKE_USER_CREATE,
      FAKE_USER_EDIT,
      FAKE_USER_DELETE,
      PUBLICATION_CREATE,
      PUBLICATION_HISTORY,
    ],
  },
  ONBOARDING: {
    title: 'administration.permissions_onboarding',
    permissions: [ONBOARDING_LIST, ONBOARDING_CREATE, ONBOARDING_DELETE, ONBOARDING_HISTORY],
  },
  DICTIONARY: {
    title: 'administration.permissions_dictionaries',
    permissions: [
      DICTIONARY_LIST,
      DICTIONARY_CREATE,
      DICTIONARY_EDIT,
      DICTIONARY_VERIFY,
      DICTIONARY_DELETE,
      DICTIONARY_HISTORY,
    ],
  },
  NEWS: {
    title: 'administration.permissions_news',
    permissions: [NEWS_LIST, NEWS_CREATE, NEWS_EDIT, NEWS_DELETE, NEWS_PUBLISH, NEWS_HISTORY],
  },
  RADAR: {
    title: 'administration.permissions_radar',
    permissions: [RADAR_LIST, RADAR_EDIT],
  },
  KEYWORDS: {
    title: 'administration.permissions_keywords',
    permissions: [
      KEYWORDS_LIST,
      KEYWORDS_CREATE,
      KEYWORDS_EDIT,
      KEYWORDS_DELETE,
      KEYWORDS_VIOLATIONS_LIST,
      KEYWORDS_HISTORY,
    ],
  },
  COMPLAINTS: {
    title: 'administration.permissions_complaints',
    permissions: [COMPLAINTS_LIST, COMPLAINTS_RESOLVE, COMPLAINTS_HISTORY],
  },
  SETTINGS: {
    title: 'administration.permissions_settings',
    permissions: [SETTINGS_LIST, SETTINGS_EDIT, SETTINGS_HISTORY],
  },
  LOCALIZATION: {
    title: 'administration.permissions_localization',
    permissions: [
      LOCALIZATION_LIST,
      LOCALIZATION_LANGUAGE_CREATE,
      LOCALIZATION_LANGUAGE_EDIT,
      LOCALIZATION_LANGUAGE_DELETE,
      LOCALIZATION_LANGUAGE_PUBLISH,
      LOCALIZATION_EDIT,
      LOCALIZATION_CLEAR,
      LOCALIZATION_HISTORY,
    ],
  },
  GIFTS: {
    title: 'administration.permissions_gifts',
    permissions: [
      GIFT_VIEW,
      GIFT_EDIT,
      GIFT_CATEGORY_VIEW,
      GIFT_CATEGORY_EDIT,
      GIFT_CATEGORY_DELETE,
    ]
  },
  MARKET: {
    title: 'administration.permissions_market',
    permissions: [
      MARKET_LIST,
      MARKET_CREATE,
      MARKET_EDIT,
      MARKET_DELETE,
    ]
  },
  JJ_COINS: {
    title: 'administration.permissions_coin',
    permissions: [
      COIN_PACKET_VIEW,
      COIN_PACKET_DELETE,
      COIN_PACKET_EDIT,
    ]
  },
  JJ_FORTUNE: {
    title: 'administration.permissions_jj_fortune',
    permissions: [
      JJFORTUNE_VIEW,
      JJFORTUNE_EDIT,
    ],
  },
};
